import { createApp, } from 'vue'
import { createPinia } from 'pinia'
import Errormonitoring from './error_watch/errorHandler'
import "./font/font.css";
// 导入动画库
import 'animate.css';
import './style.css'
import './Firebase/firebase'; // 确保Firebase初始化
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import App from './App.vue'
import router from './router/router'
import i18n from './i18n/index/index';
import VueLazyload from 'vue3-lazyload'
// import VConsole from 'vconsole';


import { createHead } from '@unhead/vue'

// import autoupdate from '@/autoupdate/update'
import screenshort from 'vue-web-screen-shot';
// import TaskQueue from './';
const pinia = createPinia()
const head = createHead()
const app = createApp(App)
// 挂载路由
app.use(router)
app.use(ElementPlus)
app.use(VueLazyload, {
    preLoad: 1.3,
    error: "./assets/Homeimg/img/socials@2x.png",
    attempt: 1,
    lifecycle: {
        loaded(el: any) {

            // console.log(el.classList, '图片加载完成_______________________________________');
            el.classList.add('loaded');
        }
    }
})
// 挂载全局错误监听监听
window.onerror = ((message, filename, lineno, colno, error) => {
    console.log(error, '报错监听', { '错误对象': error });
    try {
        Errormonitoring.errorHandler({
            'message': message,
            'filename': filename,
            'lineno': lineno,
            'colno': colno,
            'errornode': error
        })
    } catch (error) {
        throw error
    }

})
// vue组件错误监听
app.config.errorHandler = ((error: any, instance: any, info: any) => {
    console.log({ 'message': error.message, 'instance': instance.$.vnode.type.__file, 'info': info });
    try {
        Errormonitoring.vueerrorHandler({ 'message': error.message, 'instance': instance.$.vnode.type.__file, 'info': info })
    } catch (error) {
        throw error
    }


})
// 资源加载错误监听
window.addEventListener('error', (e: any) => {
    if (e.target.nodeName == 'IMG' || e.target.nodeName == 'VIDEO') {
        console.log(e, '资源报错监听');
        try {
            Errormonitoring.resourceerror(e)
        } catch (error) {
            throw error
        }



    } else if (e.target.nodeName == 'SCRIPT') {
        try {
            Errormonitoring.scripterror(e)
        } catch (error) {
            throw error
        }

    }
}, true)
// Promise错误监听
window.addEventListener("unhandledrejection", function (e) {
    console.log(e, 'Promise报错监听');
    try {
        Errormonitoring.errorHandler(e)
    } catch (error) {
        throw error
    }

})

// // 挂载i18n
app.use(i18n);
// 挂载pinia
app.use(pinia)
//导入修改head插件
app.use(head)
//挂载截图插件
app.use(screenshort, { enableWebRtc: true, level: 9999 });
app.mount('#app')
// if (process.env.NODE_ENV === 'development') {
// 只在开发环境下加载 vconsole
// const vConsole = new VConsole(); // 初始化 vconsole

// }